var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggleSwitch2',{attrs:{"title":_vm.$t('settings.showAppointments.title'),"help":_vm.$t('settings.showAppointments.info'),"value":_vm.data,"callback":_vm.setValue}})}
var staticRenderFns = []

export { render, staticRenderFns }